export enum SituacaoVeiculo {
	ATIVO = <number>1,
	CEDIDO_TERCEIROS = <number>2,
	EM_MANUTENCAO = <number>3,
	FURTADO = <number>4,
	INATIVO = <number>5,
	SINISTRADO = <number>6

}
